import { Observable } from 'rxjs/Observable';
var LockGuard = /** @class */ (function () {
    function LockGuard() {
    }
    LockGuard.prototype.checkForLock = function (systemName, formName, instanceId, formId) {
        return Observable.of(true);
    };
    return LockGuard;
}());
export { LockGuard };
//# sourceMappingURL=lock.guard.js.map